<form [formGroup]="userForm">
	<div class="card-infos grid-6">
		<mat-form-field floatLabel="always">
			<mat-label translate>add-user.user-firstname</mat-label>
			<input matInput formControlName="firstName" type="text" spellcheck="false" autocomplete="off"
				maxlength="50" required>
			<mat-icon matSuffix class="div-mat-input-icon copo-orange-text-icon" svgIcon="md:edit"></mat-icon>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<mat-label translate>add-user.user-lastname</mat-label>
			<input matInput formControlName="lastName" type="text" spellcheck="false" autocomplete="off"
				maxlength="50" required>
			<mat-icon matSuffix class="div-mat-input-icon copo-orange-text-icon" svgIcon="md:edit"></mat-icon>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always" class="email">
			<mat-label translate>add-user.user-email</mat-label>
			<input matInput formControlName="email" type="text" spellcheck="false" autocomplete="off" maxlength="100" required>
			<mat-icon matSuffix class="div-mat-input-icon copo-orange-text-icon" svgIcon="md:edit"></mat-icon>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
		<mat-form-field floatLabel="always">
			<mat-label translate>add-user.user-type</mat-label>
			<mat-select formControlName="userType" required>
				<mat-option value="user">
					<div translate>organizationrole.user</div>
				</mat-option>
				<mat-option value="subscription">
					<div translate>quapp.notification</div>
				</mat-option>
			</mat-select>
			<mat-error translate>add-user.required</mat-error>
		</mat-form-field>
	</div>
	<div class="card-infos">
		<mat-checkbox labelPosition="after" formControlName="administrator" [checked]="administrator"
			[disabled]="isSubscriptionSelected">
			<span translate>add-user.admin-user</span>
		</mat-checkbox>
	</div>
</form>
